import { render, staticRenderFns } from "./TermsDetailDefaultLayout.vue?vue&type=template&id=689c55d5&scoped=true"
import script from "./TermsDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./TermsDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c55d5",
  null
  
)

export default component.exports